export const columns = (languages) => {
  const languageColumns = languages.map((language) => ({
    accessorKey: language.slug,
    header: `${language.title} (${language.code.toUpperCase()})`,
  }));

  return [
    {
      accessorKey: "key",
      header: "Key",
    },
    ...languageColumns,
  ];
};
